
// Base.
import Vue from 'vue'

import { Prop } from 'vue-property-decorator'
import Component from 'vue-class-component'

import BlueButton from '../Atomic/BlueButton.vue'
import GreenButton from '../Atomic/GreenButton.vue'
import RedButton from '../Atomic/RedButton.vue'
import CardTitle from '../Atomic/CardTitle.vue'
import Event from '../../models/event'
import ToolTipButton from '@/components/Atomic/ToolTipButton.vue'

@Component({
  components: {
    ToolTipButton,
    BlueButton,
    GreenButton,
    RedButton,
    CardTitle,
  },
})
export default class ExportEvents extends Vue {
  // Used for CSV Export.
  private jsonMeta: any = [{ key: 'charset', value: 'utf-8' }]
  private jsonFieldsWithPassword: any = {}

  @Prop() private readonly events!: Event[]

  private dialog: boolean = false

  constructor() {
    super()
  }

  public mounted() {
    this.initialize()
  }

  private initialize() {
    for (const event of this.events) {
      event.status = event.status ? 'Réussite' : 'Echec'
    }
    this.setCsvExportConfig()
  }

  private setCsvExportConfig() {
    this.jsonFieldsWithPassword[this.$t('EVENT.School').toString()] =
      'schoolName'
    this.jsonFieldsWithPassword[this.$t('EVENT.ActionTypeLabel').toString()] = 'actionType'
    this.jsonFieldsWithPassword[this.$t('EVENT.UsernameLabel').toString()] = 'username'
    this.jsonFieldsWithPassword[this.$t('EVENT.DateLabel').toString()] = 'dateOfIssue'
    this.jsonFieldsWithPassword[this.$t('EVENT.InformationLabel').toString()] =
      'information'
    this.jsonFieldsWithPassword[this.$t('EVENT.Status').toString()] = 'status'
  }
}
